import { IconSize } from 'assets/icons/icon-sizes';
import ScheduleIcon from 'assets/icons/navigation/ScheduleIcon';
import { FlexCol, BodyLarge, FlexAlignCenter, FlexMd, FlexMdAlignCenter } from 'components/Elements';
import styled from 'styled-components';
import { breakpoints, sizes } from 'theme';
import strings from '../../strings/strings.json';
import { PaddedCardFitContent } from 'pages/learner/sharedStyles/LearnerStyles';
import ProgressBar from 'components/progressBar/ProgressBar';

type DateSectionProps = {
    startDate: Date;
    endDate?: Date;
    currentLearners: number;
    maximumLearners: number;
    joinCourseButton: JSX.Element;
    shareCourseButton: JSX.Element;
};

export default function DateSection({
    startDate,
    endDate,
    currentLearners,
    maximumLearners,
    shareCourseButton,
    joinCourseButton,
}: DateSectionProps) {
    const formattedStartDate = new Date(startDate).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
    });

    let formattedEndDate;

    if (endDate) {
        endDate = new Date(endDate);
        formattedEndDate = endDate.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
        });
    }

    return (
        <PaddedCardFitContent>
            <ScheduleInfoContainer>
                <FlexMd>
                    <DateAndIconContainer>
                        <ScheduleIcon size={IconSize.LARGE} />
                        <FlexCol>
                            <BodyLarge $nowrap>{strings.publicCoursePage.startDate}</BodyLarge>
                            <BodyLarge $bold $nowrap>
                                {formattedStartDate}
                            </BodyLarge>
                        </FlexCol>
                    </DateAndIconContainer>
                    {endDate && (
                        <DateAndIconContainer>
                            <ScheduleIcon size={IconSize.LARGE} />
                            <FlexCol>
                                <BodyLarge $nowrap>{strings.publicCoursePage.endDate}</BodyLarge>
                                <BodyLarge $bold $nowrap>
                                    {formattedEndDate}
                                </BodyLarge>
                            </FlexCol>
                        </DateAndIconContainer>
                    )}
                </FlexMd>

                <ProgressBarContainer>
                    <ProgressBar
                        label={strings.publicCoursePage.progressBarLabel}
                        current={currentLearners}
                        max={maximumLearners}
                        reverseFractionAmount
                        textBeforeBar
                    />
                </ProgressBarContainer>

                <ButtonContainer>
                    {shareCourseButton}
                    {joinCourseButton}
                </ButtonContainer>
            </ScheduleInfoContainer>
        </PaddedCardFitContent>
    );
}

const DateAndIconContainer = styled(FlexAlignCenter)`
    gap: 12px;
`;

const ScheduleInfoContainer = styled(FlexAlignCenter)`
    flex-wrap: wrap;
    gap: ${sizes.spacingLg} ${sizes.spacingXl};
    margin-top: ${sizes.spacingMd};
`;

const ProgressBarContainer = styled.div`
    width: 300px;
`;

const ButtonContainer = styled(FlexMdAlignCenter)`
    width: fit-content;

    @media (max-width: ${breakpoints.sm}) {
        width: 100%;
        flex-direction: column;
        align-items: flex-start;
    }
`;
